import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-nevada-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./nevada-state-form.component.html",
  styleUrl: "./nevada-state-form.component.scss",
})
export class NevadaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
